import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_awt663at: FaireBrandEntity = {
  token: "b_awt663at",
  type: "brand",
  name: "Broken Top Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/a8c18c47d399c85c79e9bb201f45d8fd76832eec8c2380716d7eea77ad2909d2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8db592e5adf0353d46ab5704aa471fd78281b6198305558813f280d9330e6be8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a8c18c47d399c85c79e9bb201f45d8fd76832eec8c2380716d7eea77ad2909d2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8db592e5adf0353d46ab5704aa471fd78281b6198305558813f280d9330e6be8.png",
  location: "Bend, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 394,
  isTopShop: true,
  isInsider: true,
  description:
    "Broken Top Brands is a women-owned lifestyle company of affordable luxury. Founded in 2015 as a candle company, Broken Top has grown past its name to offer an array of home and body products, while becoming a leading soy candle manufacturer, nestled in the Cascade Mountain range in Bend, Oregon.\n\nOur products are hand-crafted in small batches, made in the U.S., and are gluten-free, paraben-free, phthalate-free, and are loved by men and women alike. Our hand-poured candles are made using only premium U.S.-grown soybean wax, all-natural cotton-braided wicks, and phthalate-free fragrance oils infused with essential oils. We believe that sustainable, eco-conscious products should be affordable, yet luxurious and healthy to fit into everyone’s lifestyle.\n\nTry us on for scent and choose the best natural products for your business!\n\nAs a family owned small business, lead times may be slightly extended during peak buying periods such as Faire Winter Market, Faire Summer Market, and the holiday season. We always do our best to ship orders as quickly as possible and truly appreciate your patience during high volume times.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:20.551Z",
    importedBy: "entity-db-cli",
  },
};
